import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchFaqsNotesDocuments } from '../../store/actions/faqsNotesDocuments';
import { fetchAllIssueTypes } from '../../store/actions/formOptions';
import { ICONS } from '../../common/constants';
import { selectServiceRequestFormData } from '../../store/selectors/serviceRequestForm';
import {
  setServiceRequestFormData,
  setServiceRequestFormNextStep,
  setServiceRequestFormStep,
  setServiceRequestFormPreviousStep,
  exitServiceRequestForm,
} from '../../store/actions/serviceRequestForm';
import Button from '../Button';
import Col from '../Col';
import Diagnosis from '../Diagnosis/Diagnosis';
import Form from '../Form';
import FontAwesomeIcon from '../Icon';
import Progress from './Progress';
import Row from '../Row';
import Tile from '../Tile';
import { selectFaqByIssueType } from '../../store/selectors/faqsNotesDocuments';
import { selectAuthenticatedUser } from '../../store/selectors/auth';

class ServiceRequestFormIssueType extends Component {
  state = {
    faqs: [],
  };

  componentDidMount() {
    const {
      serviceRequestFormData,
      onSetServiceRequestFormData,
      types,
      faqsNotesDocuments,
    } = this.props;
    if (
      serviceRequestFormData &&
      !serviceRequestFormData.issueType &&
      !serviceRequestFormData.issueTypeId
    ) {
      let issueType = types.filter((a) => a.name === 'General')[0];
      onSetServiceRequestFormData({
        issueType: issueType.name,
        issueTypeId: issueType.id,
      });
    }
    let faqs =
      faqsNotesDocuments.length > 0
        ? faqsNotesDocuments.filter((item) => item.type === 'FAQS')
        : [];
    this.setState({ faqs: faqs });
  }

  render() {
    const {
      types,
      serviceRequestFormData,
      onSetServiceRequestFormData,
      onSetServiceRequestFormNextStep,
      onSetServiceRequestFormPreviousStep,
      onExitServiceRequestForm,
      onExit,
      itemFaqCategories,
      onSetServiceRequestFormStep,
      user,
    } = this.props;
    let issueType = types.filter((a) => a.name === 'General')[0];
    return (
      <Form
        headline="Let’s Identify the Issue"
        strapline="Tell us what’s happening and we’ll  be able to find the right solution to get your home back to normal."
        onClose={() => {
          onSetServiceRequestFormPreviousStep();
        }}
        onExit={() => {
          onExitServiceRequestForm();
          if (onExit) onExit();
        }}
        component={
          <Row mdCenter>
            <Col xs="12" md="6">
              <Diagnosis
                asset={serviceRequestFormData.asset_item_nameDescription}
                issueType={serviceRequestFormData.issueType}
                expiresAt={serviceRequestFormData.assetWarrantyExpiresAt}
              />
              <Progress currentStep={1} totalSteps={3} />
              <Row granola>
                {user.roles[0].role.name === 'Home Owner' ? (
                  <Col granola key={issueType.name} xs="6" md="4">
                    <Tile
                      icon={
                        <FontAwesomeIcon
                          weight="light"
                          glyph={ICONS[issueType.name]}
                        />
                      }
                      active={
                        issueType.name === serviceRequestFormData.issueType
                      }
                      onClick={() =>
                        onSetServiceRequestFormData({
                          issueType: issueType.name,
                          issueTypeId: issueType.id,
                        })
                      }
                      title={
                        issueType.name === 'Heating/Cooling'
                          ? 'Heating / Cooling'
                          : issueType.name
                      }
                      size="tiny"
                    />
                  </Col>
                ) : (
                  types.map((issueType) => (
                    <Col granola key={issueType.name} xs="6" md="4">
                      <Tile
                        icon={
                          <FontAwesomeIcon
                            weight="light"
                            glyph={ICONS[issueType.name]}
                          />
                        }
                        active={
                          issueType.name === serviceRequestFormData.issueType
                        }
                        onClick={() =>
                          onSetServiceRequestFormData({
                            issueType: issueType.name,
                            issueTypeId: issueType.id,
                          })
                        }
                        title={
                          issueType.name === 'Heating/Cooling'
                            ? 'Heating / Cooling'
                            : issueType.name
                        }
                        size="tiny"
                      />
                    </Col>
                  ))
                )}
              </Row>
            </Col>
          </Row>
        }
        footer={
          <div
            style={{
              position: 'fixed',
              bottom: '0',
              left: '0',
              width: '100%',
              background: '#fff',
              padding: '15px',
              boxShadow: '0 0 0.3rem rgba(0, 0, 0, 0.3)',
            }}
          >
            {user.roles[0].role.name === 'Home Owner' ? (
              this.state.faqs.length > 0 ? (
                <Button
                  color="teal"
                  size="small"
                  label="Next: Common Questions"
                  onClick={() => onSetServiceRequestFormNextStep()}
                  disabled={!serviceRequestFormData.issueType}
                />
              ) : (
                <Button
                  color="teal"
                  size="small"
                  label="NEXT: ADD DETAILS"
                  onClick={() => onSetServiceRequestFormStep(6)}
                  disabled={!serviceRequestFormData.issueType}
                />
              )
            ) : serviceRequestFormData.issueType ? (
              itemFaqCategories.length > 0 ? (
                <Button
                  color="teal"
                  size="small"
                  label="Next: Common Questions"
                  onClick={() => onSetServiceRequestFormNextStep()}
                  disabled={!serviceRequestFormData.issueType}
                />
              ) : (
                <Button
                  color="teal"
                  size="small"
                  label="NEXT: ADD DETAILS"
                  onClick={() => onSetServiceRequestFormStep(6)}
                  disabled={!serviceRequestFormData.issueType}
                />
              )
            ) : (
              <>
                Please select issue type !
                <br />
                <br />
              </>
            )}
          </div>
        }
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const serviceRequestFormData = selectServiceRequestFormData(state);

  return {
    types: state.formOptions.types,
    serviceRequestFormData,
    itemFaqCategories: selectFaqByIssueType(
      state,
      serviceRequestFormData.issueType
    ),
    user: selectAuthenticatedUser(state),
    faqsNotesDocuments: state.faqsNotesDocuments,
  };
};

const maptDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onFetchIssueTypes: fetchAllIssueTypes,
      onFetchFaqsNotesDocuments: fetchFaqsNotesDocuments,
      onSetServiceRequestFormData: setServiceRequestFormData,
      onSetServiceRequestFormNextStep: setServiceRequestFormNextStep,
      onSetServiceRequestFormPreviousStep: setServiceRequestFormPreviousStep,
      onExitServiceRequestForm: exitServiceRequestForm,
      onSetServiceRequestFormStep: setServiceRequestFormStep,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  maptDispatchToProps
)(ServiceRequestFormIssueType);
